exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".loader[data-v-159346dd]{width:82px;height:82px;background:url(\"/src/components/Common/Loader/Images/loader_new.gif\");position:fixed;top:50%;left:50%;margin-left:-41px;margin-top:-41px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"optionsId":"0","vue":true,"id":"data-v-159346dd","scoped":true,"sourceMap":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Common/Loader/Loader.vue
// module id = 82
// module chunks = 20